import { useEffect, useRef, useState } from "react";
import {
  TDiagnosticParams,
  TDiagnosticParamsInsItem,
} from "../api/types/diagnostic-dialog.interface";
import { useModalContext } from "../../../context/ModalContext";
import { abortDiagnostic, closeDiagnostic } from "../api/diagnostic-dialog";

export function useDiagnosticDevice() {
  const [diagnosticData, setDiagnosticData] =
    useState<TDiagnosticParams | null>(null);
  const [isClosed, setIsClosed] = useState<boolean>(false);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("");
  const [foundedOptions, setFoundedOptions] = useState<
    TDiagnosticParamsInsItem[]
  >([]);
  const { closeModal } = useModalContext();

  useEffect(() => {
    setFoundedOptions([]);
  }, []);

  useEffect(() => {
    if (!diagnosticData) return;
    if (diagnosticData.status === "finish" && isClosed) {
      closeModal();
      setIsClosed(false);
    } else if (diagnosticData.status === "finish") {
      setProgress(100);
      setStatus(diagnosticData.status);
    } else {
      setProgress(diagnosticData.pos);
      setStatus(diagnosticData.status);
    }
  }, [diagnosticData, isClosed]);

  useEffect(() => {
    if (!diagnosticData) return;
    if (diagnosticData.ins.length === 0) return;
    setFoundedOptions([...foundedOptions, ...diagnosticData.ins]);
  }, [diagnosticData]);

  const abort = async () => {
    const token = localStorage.getItem("authToken");
    if (token) {
      const abortResult = await abortDiagnostic(token);
      if (abortResult) {
        setStatus("finish");
      }
    }
  };

  const getSeverity = (str: string) => {
    switch (str) {
      case "n":
        return "success";
      case "e":
        return "danger";
      case "w":
        return "warning";
      default:
        return "info";
    }
  };

  const handleCloseDiagnostic = async () => {
    const token = localStorage.getItem("authToken");
    if (token) {
      if (diagnosticData?.status === "finish" && !isClosed) {
        closeModal();
      }
      const abortResult = await abortDiagnostic(token);

      if (abortResult && diagnosticData) {
        setIsClosed(true);
        await closeDiagnostic(token);
      }
    }
  };

  return {
    diagnosticData,
    setDiagnosticData,
    progress,
    setProgress,
    status,
    setStatus,
    foundedOptions,
    setFoundedOptions,
    abort,
    getSeverity,
    handleCloseDiagnostic,
  };
}
